(() => {
  const carousels = document.querySelectorAll('[data-bvt-carousel]');
  carousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-bvt-carousel-track]');
    if (!track) return;

    const scrollByStep = (direction) => {
      const step = Math.max(track.clientWidth * 0.78, 220);
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    };

    const previous = carousel.querySelector('[data-bvt-carousel-prev]');
    const next = carousel.querySelector('[data-bvt-carousel-next]');
    if (previous) previous.addEventListener('click', () => scrollByStep(-1));
    if (next) next.addEventListener('click', () => scrollByStep(1));
  });

  const mobileTrustQuery = window.matchMedia('(max-width: 767px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const trustTracks = document.querySelectorAll('[data-bvt-trust-track]');

  trustTracks.forEach((track) => {
    if (track.dataset.bvtTrustRailReady === 'true') return;
    track.dataset.bvtTrustRailReady = 'true';

    const pixelsPerMillisecond = 0.022;
    let frameId = null;
    let resumeId = null;
    let lastTimestamp = null;
    let originalSpan = 0;
    let scrollPosition = 0;

    const stop = () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = null;
      lastTimestamp = null;
    };

    const removeClones = () => {
      track.querySelectorAll('[data-bvt-trust-clone]').forEach((clone) => clone.remove());
      originalSpan = 0;
    };

    const ensureClones = () => {
      const originals = Array.from(track.children).filter((item) => !item.hasAttribute('data-bvt-trust-clone'));
      if (!originals.length) return;
      if (!track.querySelector('[data-bvt-trust-clone]')) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-bvt-trust-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          if (clone.matches('a, button, [tabindex]')) clone.setAttribute('tabindex', '-1');
          clone.querySelectorAll('a, button, [tabindex]').forEach((control) => control.setAttribute('tabindex', '-1'));
          track.appendChild(clone);
        });
      }
      const first = originals[0];
      const last = originals[originals.length - 1];
      originalSpan = last.offsetLeft + last.offsetWidth - first.offsetLeft;
    };

    const tick = (timestamp) => {
      if (!mobileTrustQuery.matches || reducedMotionQuery.matches || document.hidden) {
        stop();
        return;
      }
      if (lastTimestamp === null) lastTimestamp = timestamp;
      const elapsed = Math.min(timestamp - lastTimestamp, 64);
      // Preserve fractional movement; scrollLeft may round each subpixel write.
      scrollPosition += elapsed * pixelsPerMillisecond;
      if (originalSpan > 0) scrollPosition %= originalSpan;
      track.scrollLeft = scrollPosition;
      lastTimestamp = timestamp;
      frameId = window.requestAnimationFrame(tick);
    };

    const start = () => {
      stop();
      if (!mobileTrustQuery.matches || reducedMotionQuery.matches || document.hidden) return;
      ensureClones();
      scrollPosition = track.scrollLeft;
      frameId = window.requestAnimationFrame(tick);
    };

    const pauseForInteraction = () => {
      stop();
      if (resumeId) window.clearTimeout(resumeId);
      resumeId = window.setTimeout(start, 4000);
    };

    const syncMode = () => {
      if (resumeId) window.clearTimeout(resumeId);
      if (mobileTrustQuery.matches && !reducedMotionQuery.matches) start();
      else {
        stop();
        removeClones();
        track.scrollLeft = 0;
      }
    };

    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach((eventName) => {
      track.addEventListener(eventName, pauseForInteraction, { passive: true });
    });
    mobileTrustQuery.addEventListener('change', syncMode);
    reducedMotionQuery.addEventListener('change', syncMode);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });
    syncMode();
  });
})();
